(function () {
  var FREE_SHIPPING = 34900;
  var MAX_UPSELLS = 3;

  function init() {
    var overlay  = document.getElementById('ur-cart-overlay');
    var drawer   = document.getElementById('ur-cart-drawer');
    if (!overlay || !drawer) {
      console.warn('[UR Cart] Drawer elements not found');
      return;
    }
    var closeBtn = document.getElementById('ur-cart-close');
    var countEl  = document.getElementById('ur-cd-count');
    var itemsEl  = document.getElementById('ur-cd-items');
    var footerEl = document.getElementById('ur-cd-footer');
    var subtotal = document.getElementById('ur-cd-subtotal');
    var shipBar  = document.getElementById('ur-cd-shipping-bar');
    var shipMsg  = document.getElementById('ur-cd-shipping-msg');
    var barFill  = document.getElementById('ur-cd-bar-fill');
    var upsellsEl     = document.getElementById('ur-cd-upsells');
    var upsellsListEl = document.getElementById('ur-cd-upsells-list');

    function money(cents) {
      return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',');
    }

    function escapeHtml(s) {
      return String(s || '').replace(/[&<>"']/g, function (c) {
        return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]);
      });
    }

    function openDrawer() {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          renderCart(cart);
          renderUpsells(cart);
        })
        .catch(function (err) { console.error('[UR Cart] fetch failed', err); });
      overlay.classList.add('is-open');
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      overlay.classList.remove('is-open');
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function renderShippingBar(totalPrice) {
      if (!shipBar || !shipMsg || !barFill) {
        console.warn('[UR Cart] shipping bar elements missing', { shipBar: !!shipBar, shipMsg: !!shipMsg, barFill: !!barFill });
        return;
      }
      // Belt-and-suspenders: ensure bar is visible
      shipBar.hidden = false;
      shipBar.removeAttribute('hidden');
      shipBar.style.display = '';
      shipBar.setAttribute('data-ur-cart-total', totalPrice);

      var rem = FREE_SHIPPING - totalPrice;
      var targetPct;
      if (rem > 0) {
        shipMsg.innerHTML = '<span class="ur-cd__shipping-label">QUASE LÁ!</span> Adicione <strong>' + money(rem) + '</strong> para ganhar frete grátis.';
        targetPct = Math.max(3, Math.min(98, Math.round(totalPrice / FREE_SHIPPING * 100)));
      } else {
        shipMsg.innerHTML = '<span class="ur-cd__shipping-label">FRETE GRÁTIS</span> desbloqueado!';
        targetPct = 100;
      }

      // Use setProperty with !important to defeat any conflicting CSS
      barFill.style.setProperty('width', targetPct + '%', 'important');
    }

    function renderCart(cart) {
      if (countEl) countEl.textContent = '(' + cart.item_count + ')';

      if (cart.item_count === 0) {
        if (itemsEl) {
          itemsEl.innerHTML = '<div class="ur-cd__empty"><p class="ur-cd__empty-text">Seu carrinho está vazio.</p><a href="/collections" class="ur-cd__empty-link">Ver Coleção →</a></div>';
        }
        if (footerEl) footerEl.style.display = 'none';
        if (shipBar) shipBar.hidden = true;
        if (upsellsEl) upsellsEl.hidden = true;
        return;
      }

      if (footerEl) footerEl.style.display = '';
      if (subtotal) subtotal.textContent = money(cart.total_price);
      renderShippingBar(cart.total_price);

      var html = '';
      cart.items.forEach(function (item) {
        var imgHtml = (item.featured_image && item.featured_image.url)
          ? '<img src="' + item.featured_image.url + '" alt="' + escapeHtml(item.title) + '" width="72" height="72" loading="lazy">'
          : '<div class="ur-cd__item-img--ph"></div>';
        var meta = (item.variant_title && item.variant_title !== 'Default Title')
          ? '<span class="ur-cd__item-meta">Tam. ' + escapeHtml(item.variant_title) + '</span>'
          : '';

        html += '<div class="ur-cd__item" data-item-key="' + item.key + '">';
        html +=   '<div class="ur-cd__item-img">' + imgHtml + '</div>';
        html +=   '<div class="ur-cd__item-info">';
        html +=     '<span class="ur-cd__item-title">' + escapeHtml(item.product_title) + '</span>';
        html +=     meta;
        html +=     '<span class="ur-cd__item-price">' + money(item.final_line_price) + '</span>';
        html +=     '<div class="ur-cd__item-qty">';
        html +=       '<button class="ur-cd__qty-btn" data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '"' + (item.quantity <= 1 ? ' disabled' : '') + '>−</button>';
        html +=       '<span class="ur-cd__qty-val">' + item.quantity + '</span>';
        html +=       '<button class="ur-cd__qty-btn" data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '">+</button>';
        html +=     '</div>';
        html +=   '</div>';
        html +=   '<button class="ur-cd__item-remove" data-key="' + item.key + '" aria-label="Remover">';
        html +=     '<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><line x1="1" y1="1" x2="9" y2="9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><line x1="9" y1="1" x2="1" y2="9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
        html +=   '</button>';
        html += '</div>';
      });

      if (itemsEl) itemsEl.innerHTML = html;
    }

    /* ============ Recommendations / Upsells ============ */

    function renderUpsells(cart) {
      if (!upsellsEl || !upsellsListEl) return;
      if (!cart || !cart.items || cart.items.length === 0) {
        upsellsEl.hidden = true;
        return;
      }

      // Fetch complementary recommendations for each cart item, dedup, exclude items in cart.
      // The fallback collection (one-size accessories) fills the list when there are no complementary picks.
      var requests = cart.items.map(function (item) {
        var url = '/recommendations/products.json?product_id=' + item.product_id + '&limit=4&intent=complementary';
        return fetch(url).then(function (r) { return r.json(); }).catch(function () { return { products: [] }; });
      });
      var fallbackHandle = upsellsEl.dataset.fallbackCollection;
      if (fallbackHandle) {
        requests.push(
          fetch('/collections/' + encodeURIComponent(fallbackHandle) + '/products.json?limit=8')
            .then(function (r) { return r.json(); })
            .catch(function () { return { products: [] }; })
        );
      }

      Promise.all(requests).then(function (results) {
        var cartIds = {};
        cart.items.forEach(function (i) { cartIds[i.product_id] = true; });

        var seen = {};
        var picks = [];
        for (var r = 0; r < results.length && picks.length < MAX_UPSELLS; r++) {
          var products = (results[r] && results[r].products) || [];
          for (var p = 0; p < products.length && picks.length < MAX_UPSELLS; p++) {
            var prod = products[p];
            if (!prod || cartIds[prod.id] || seen[prod.id]) continue;
            if (!(prod.variants || []).some(function (v) { return v.available; })) continue;
            seen[prod.id] = true;
            picks.push(prod);
          }
        }

        if (picks.length === 0) {
          upsellsEl.hidden = true;
          upsellsListEl.innerHTML = '';
          return;
        }

        var html = '';
        picks.forEach(function (prod) {
          var firstAvailable = (prod.variants || []).find(function (v) { return v.available; });
          if (!firstAvailable) firstAvailable = (prod.variants || [])[0];
          if (!firstAvailable) return;

          var imgUrl = '';
          if (prod.featured_image && typeof prod.featured_image === 'string') {
            imgUrl = prod.featured_image;
          } else if (prod.featured_image && prod.featured_image.url) {
            imgUrl = prod.featured_image.url;
          } else if (prod.media && prod.media[0] && prod.media[0].preview_image) {
            imgUrl = prod.media[0].preview_image.src || prod.media[0].preview_image.url;
          } else if (prod.images && prod.images[0]) {
            imgUrl = typeof prod.images[0] === 'string' ? prod.images[0] : (prod.images[0].url || prod.images[0].src);
          }

          var imgHtml = imgUrl
            ? '<img src="' + imgUrl + '" alt="' + escapeHtml(prod.title) + '" loading="lazy">'
            : '';

          var price = (firstAvailable.price !== undefined ? firstAvailable.price : prod.price);
          if (typeof price === 'string') price = parseInt(price.replace(/\D/g, ''), 10);
          // /products.json entries have no url, only handle
          var prodUrl = prod.url || ('/products/' + prod.handle);

          html += '<div class="ur-cd__upsell" role="listitem" data-product-id="' + prod.id + '">';
          html +=   '<a href="' + prodUrl + '" class="ur-cd__upsell-img">' + imgHtml + '</a>';
          html +=   '<div class="ur-cd__upsell-info">';
          html +=     '<a href="' + prodUrl + '" class="ur-cd__upsell-title">' + escapeHtml(prod.title) + '</a>';
          html +=     '<span class="ur-cd__upsell-price">' + money(price) + '</span>';
          html +=   '</div>';
          // One-click add only when there is no size to choose
          if ((prod.variants || []).length === 1) {
            html +=   '<button class="ur-cd__upsell-add" data-variant-id="' + firstAvailable.id + '" aria-label="Adicionar ' + escapeHtml(prod.title) + ' ao carrinho">';
            html +=     '<span aria-hidden="true">+</span> ADD';
            html +=   '</button>';
          } else {
            html +=   '<a href="' + prodUrl + '" class="ur-cd__upsell-add" aria-label="Escolher tamanho de ' + escapeHtml(prod.title) + '">Ver</a>';
          }
          html += '</div>';
        });

        upsellsListEl.innerHTML = html;
        upsellsEl.hidden = false;
        upsellsEl.open = true;
      });
    }

    function addUpsell(variantId, btn) {
      if (!variantId) return;
      btn.disabled = true;
      var originalHtml = btn.innerHTML;
      btn.innerHTML = '<span aria-hidden="true">⏳</span> ADD';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
        .then(function (cart) {
          btn.classList.add('ur-cd__upsell-add--added');
          btn.innerHTML = '✓ ADICIONADO';
          renderCart(cart);
          updateBubble(cart.item_count);
          // Re-fetch upsells (may change since cart changed)
          setTimeout(function () { renderUpsells(cart); }, 600);
        })
        .catch(function (err) {
          console.error('[UR Cart] add upsell failed', err);
          btn.disabled = false;
          btn.innerHTML = originalHtml;
        });
    }

    function flagStockLimit(key, available) {
      var row = itemsEl && itemsEl.querySelector('.ur-cd__item[data-item-key="' + key + '"]');
      if (!row) return;
      var info = row.querySelector('.ur-cd__item-info');
      if (!info) return;
      var old = info.querySelector('.ur-cd__item-stock-msg');
      if (old) old.remove();
      var msg = document.createElement('span');
      msg.className = 'ur-cd__item-stock-msg';
      msg.textContent = (typeof available === 'number')
        ? 'Só temos ' + available + ' em estoque.'
        : 'Quantidade máxima em estoque atingida.';
      info.appendChild(msg);
    }

    function changeQty(key, qty) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          // Resposta de erro do Shopify não traz .items — recarrega o estado real.
          if (!cart || !cart.items) {
            return fetch('/cart.js')
              .then(function (r) { return r.json(); })
              .then(function (live) {
                renderCart(live);
                renderUpsells(live);
                updateBubble(live.item_count);
                if (qty > 0) flagStockLimit(key);
              });
          }
          renderCart(cart);
          renderUpsells(cart);
          updateBubble(cart.item_count);
          // Shopify limita a quantidade ao estoque disponível: se foi aplicado
          // menos do que pedimos, o item bateu o teto de estoque.
          if (qty > 0) {
            var applied = cart.items.filter(function (i) { return i.key === key; })[0];
            if (applied && applied.quantity < qty) flagStockLimit(key, applied.quantity);
          }
        })
        .catch(function (err) { console.error('[UR Cart] changeQty failed', err); });
    }

    function updateBubble(count) {
      var bubble = document.querySelector('.cart-count-bubble span[aria-hidden]');
      if (bubble) bubble.textContent = count;
    }

    document.addEventListener('click', function (e) {
      var cartIcon = e.target.closest('#cart-icon-bubble');
      if (cartIcon) {
        e.preventDefault();
        e.stopImmediatePropagation();
        openDrawer();
        return;
      }
      var qtyBtn = e.target.closest('.ur-cd__qty-btn');
      if (qtyBtn && drawer.contains(qtyBtn)) {
        var qty = parseInt(qtyBtn.dataset.qty, 10);
        if (!isNaN(qty)) changeQty(qtyBtn.dataset.key, qty);
        return;
      }
      var rmBtn = e.target.closest('.ur-cd__item-remove');
      if (rmBtn && drawer.contains(rmBtn)) {
        changeQty(rmBtn.dataset.key, 0);
        return;
      }
      var addBtn = e.target.closest('.ur-cd__upsell-add[data-variant-id]');
      if (addBtn && drawer.contains(addBtn)) {
        addUpsell(addBtn.dataset.variantId, addBtn);
        return;
      }
    }, true);

    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    overlay.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });

    document.addEventListener('ur:cart:open', openDrawer);
    document.addEventListener('ur:cart:refresh', function () {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          renderCart(cart);
          renderUpsells(cart);
          updateBubble(cart.item_count);
        });
    });

    // ALWAYS fetch live cart on init — don't trust the rendered data attribute
    // (Shopify may serve cached HTML with stale empty cart values).
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.item_count > 0) {
          renderShippingBar(cart.total_price);
          if (countEl) countEl.textContent = '(' + cart.item_count + ')';
        }
      })
      .catch(function () {});

    // Re-render bar whenever the drawer opens (catches cases where it opens
    // via mechanisms other than our click handler — e.g., other scripts).
    if (drawer && 'MutationObserver' in window) {
      var lastOpen = drawer.classList.contains('is-open');
      var drawerObs = new MutationObserver(function () {
        var nowOpen = drawer.classList.contains('is-open');
        if (nowOpen && !lastOpen) {
          fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              renderCart(cart);
              renderUpsells(cart);
            })
            .catch(function () {});
        }
        lastOpen = nowOpen;
      });
      drawerObs.observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }

    // ------- Universal cart-mutation listener -------
    // Wraps window.fetch so any /cart/{add,change,update,clear}.js call (theme,
    // app, AJAX form) triggers the drawer to refresh. Without this, the shipping
    // bar can stay stale because the legacy product form submit didn't fire any
    // custom event.
    (function patchFetch() {
      if (window.__urCartFetchPatched) return;
      window.__urCartFetchPatched = true;
      var origFetch = window.fetch;
      if (typeof origFetch !== 'function') return;
      var cartRe = /\/cart\/(add|change|update|clear)(?:\.js)?(?:\?|$)/;
      window.fetch = function (input, init) {
        var url = (typeof input === 'string') ? input : (input && input.url) || '';
        var promise = origFetch.apply(this, arguments);
        if (cartRe.test(url)) {
          promise.then(function (r) {
            // Wait a tick so Shopify has committed cart state
            setTimeout(function () {
              fetch('/cart.js')
                .then(function (rr) { return rr.json(); })
                .then(function (cart) {
                  renderCart(cart);
                  renderUpsells(cart);
                  updateBubble(cart.item_count);
                })
                .catch(function () {});
            }, 50);
          }).catch(function () {});
        }
        return promise;
      };
    })();

    // ------- Form-based add-to-cart fallback (non-AJAX) -------
    // Some product page submits without ajax. Catch it before redirect and
    // refresh the drawer when user navigates back.
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.action) return;
      if (/\/cart\/add/.test(form.action)) {
        setTimeout(function () {
          fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              renderCart(cart);
              renderUpsells(cart);
              updateBubble(cart.item_count);
            })
            .catch(function () {});
        }, 600);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
